import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface VolumeChartProps {
  data: Record<string, number>;  // {"TON": 1000, "USDT": 500}
}

export const VolumeChart = ({ data }: VolumeChartProps) => {
  const chartData = Object.entries(data).map(([token, volume]) => ({
    token,
    volume: Number(volume),
  }));

  return (
    <ResponsiveContainer width="100%" height={300}>
      <BarChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="token" />
        <YAxis />
        <Tooltip formatter={(value: number) => `$${value.toFixed(2)}`} />
        <Bar dataKey="volume" fill="#90caf9" />
      </BarChart>
    </ResponsiveContainer>
  );
};
